import { createSlice } from '@reduxjs/toolkit'
import { deleteExparience, fetchMyExpariences, fetchSingleExparience, updatePublication, updateVisible } from './expariencesThunks';

function initializeUserState() {

  let initialState = {
    loading: false,
    loadingUserExpariences: false,
    fetchingLoader: false,
    myExpariences: null,
    selectedExparience: null,
    savingLoader: false,
    backdropRequest: {
      from: '',
      status: false,
      infos: {},
    },
    headerHidden: false,
  }
  return initialState;
}

export const expariencesSlice = createSlice({
  name: 'expariences',
  initialState: initializeUserState(),
  reducers: {
    openBackdrop: (state, action) => {
      state.backdropRequest = {
        from: action.payload.from,
        status: true,
        infos: action.payload.infos,
      }
    },
    closeBackdrop: (state) => {
      state.backdropRequest = {
        from: '',
        status: false,
        infos: {},
      };
      state.selectedExparience = null;
    },
    displayMenu: (state, action) => {
      state.headerHidden = action.payload;
    },
    resetExparience: (state) => {
      state.selectedExparience = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyExpariences.pending, (state, action) => {
        state.loading = true;
        if (action.meta.arg.hasOwnProperty('dma'))
          state.myExpariences = {
            data: [],
          };
      })
      .addCase(fetchMyExpariences.fulfilled, (state, action) => {
        if (action.payload.concat) {
          if (action.payload?.reset)
            state.myExpariences = action.payload.response.data;
          else {
            if (action.payload.hasOwnProperty('dma') && action.payload.dma)
              state.myExpariences = {
                data: [...action.payload.response.data],
              }
            else if (state.myExpariences)
              state.myExpariences = [...state.myExpariences, ...action.payload.response.data];
          }
          state.hasMore = action.payload.response.hasMore;
          state.offset = action.payload.response.offset;
          state.limit = action.payload.response.limit;
          state.total = action.payload.response.total;
        } else {
          state.myExpariences = action.payload.response;
        }
        state.loading = false;
      })
      .addCase(fetchMyExpariences.rejected, (state) => {
        state.loading = false;
        state.myExpariences = [];
      })
      .addCase(fetchSingleExparience.pending, (state) => {
        state.fetchingLoader = true;
      })
      .addCase(fetchSingleExparience.fulfilled, (state, action) => {
        state.fetchingLoader = false;
        let tmp = {...action.payload}
        if (!tmp.hasOwnProperty('config'))
          tmp.config = {};
        if (!tmp.hasOwnProperty('options'))
          tmp.options = {};
        state.selectedExparience = tmp;
      })
      .addCase(fetchSingleExparience.rejected, (state) => {
        state.fetchingLoader = false;
      })
      .addCase(deleteExparience.pending, (state) => {
        state.savingLoader = true;
      })
      .addCase(deleteExparience.fulfilled, (state) => {
        state.savingLoader = false;
      })
      .addCase(deleteExparience.rejected, (state) => {
        state.savingLoader = false;
      })
      .addCase(updatePublication.pending, (state) => {
        state.savingLoader = true;
      })
      .addCase(updatePublication.fulfilled, (state, action) => {
        if (state.myExpariences) {
          state.myExpariences[state.myExpariences.findIndex(item => item.id === action.payload.id)].published = action.payload.value;
        }
        if (state.selectedExparience)
          state.selectedExparience.published = action.payload.value;
        state.savingLoader = false;
      })
      .addCase(updatePublication.rejected, (state) => {
        state.savingLoader = false;
      })
      .addCase(updateVisible.pending, () => {})
      .addCase(updateVisible.fulfilled, (state, action) => {
        if (state.myExpariences) {
          state.myExpariences[state.myExpariences.findIndex(item => item.id === action.payload.id)].visible = action.payload.visible;
        }
        if (state.selectedExparience)
          state.selectedExparience.visible = action.payload.visible;
      })
      .addCase(updateVisible.rejected, () => {})
  },
})

// Action creators are generated for each case reducer function
export const {
  openBackdrop,
  closeBackdrop,
  displayMenu,
  resetExparience,
} = expariencesSlice.actions

export default expariencesSlice.reducer